import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import Swal from 'sweetalert2';
import { VehicleService } from '../vehicle.service';
import { RiderService } from '../../riders/rider.service';

@Component({
  selector: 'app-assign-vehicle-dialog',
  templateUrl: './assign-vehicle-dialog.component.html',
  styleUrls: ['./assign-vehicle-dialog.component.scss']
})
export class AssignVehicleDialogComponent implements OnInit {
  riders: any[] = [];
  selectedRiderId: number | null = null;
  loading = false;

  constructor(
    private vehicleService: VehicleService,
    private riderService: RiderService,
    private dialogRef: MatDialogRef<AssignVehicleDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { vehicleId: number; currentRiderId?: number; plateNumber: string }
  ) {}

  ngOnInit(): void {
    this.loading = true;
    this.riderService.getRiders().subscribe({
      next: (list) => {
        this.riders = list || [];
        this.selectedRiderId = this.data.currentRiderId ?? null;
        this.loading = false;
      },
      error: (err) => {
        console.error('[AssignVehicle] ❌ Failed to load riders:', err);
        Swal.fire('Error', 'Failed to load riders', 'error');
        this.loading = false;
      }
    });
  }

  assign(): void {
    if (!this.selectedRiderId) {
      Swal.fire('Validation', 'Please select a rider', 'warning');
      return;
    }

    this.loading = true;
    this.vehicleService.assignVehicle(this.data.vehicleId, this.selectedRiderId).subscribe({
      next: () => {
        this.loading = false;
        Swal.fire('Assigned', 'Vehicle assigned to rider', 'success');
        this.dialogRef.close(true);
      },
      error: (err) => {
        this.loading = false;
        console.error('[AssignVehicle] ❌ Assign failed:', err);
        Swal.fire('Error', 'Failed to assign vehicle', 'error');
      }
    });
  }

  close(): void {
    this.dialogRef.close();
  }
}
